/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { PureComponent } from 'react';
import { array } from 'prop-types';

import Slideshow from 'components/Slideshow/Slideshow';

import styles from './quotes-block.scss';

/**
 * This is the QuotesBlock component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default class QuotesBlock extends PureComponent {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    items: array.isRequired,
  };

  /**
   * Render QuotesBlock.
   *
   * @return {Object}
   */
  render() {
    const { items } = this.props;

    return (
      <section className={styles.wrapper}>
        <Slideshow
          hasCenteredSlidesMobile
          settings={{
            loop: true,
            slidesPerView: 3,
            autoplay: {
              delay: 5000,
            },
            breakpoints: {
              // when window width is >= 768px
              768: {
                slidesPerView: 1,
              },
            },
          }}
        >
          {items.map(({ quote, author }, i) => (
            <div key={`quote-block-${i}`} className={styles.quote}>
              <h2 className={styles.text}>{quote}</h2>
              <p className={styles.author}>{author}</p>
            </div>
          ))}
        </Slideshow>
      </section>
    );
  }
}
